// extracted by mini-css-extract-plugin
module.exports = {"Notification":"Notification_Notification__sK_pX"};